import { EditorQueries, Node as CraftNode } from '@candulabs/craft';

export const traverseChildren = (
  query: EditorQueries,
  nodeId: string,
  callback: (childData: CraftNode) => boolean,
) => {
  const nodeData = query.node(nodeId);
  if (!nodeData.node) {
    return;
  }

  const exit = callback(nodeData.node);
  if (exit) {
    return;
  }
  nodeData.childNodes().forEach((childNodeId) => traverseChildren(query, childNodeId, callback));
};
